export default __webpack_public_path__ + "static/media/icon.b7826e42.svg";